import React, { useState } from 'react'
import InfoCard from '../components/CardComponent'
import ServicesCard from '../components/CardComponent/ServicesCard'
import HeroSection from '../components/HeroSection'

const Home = () => {
  return (
    <>
      <HeroSection />
      <ServicesCard />
    </>
  )
}

export default Home
